export const MIN_COUNT_SEARCH_LETTERS = 2;

export const EXTENTION_TYPE = {
	INCLUDE: 1,
	EXCLUDE: 2,
};
